/**
 * Formats a stored event field value (e.g. 'all_ages') into a presentable
 * label (e.g. 'All Ages'). Values without underscores (like '18+') pass
 * through unchanged.
 */
export const formatAgeRequirement = (value) => {
    if (!value) return value;
    return value
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
};
